<template>
  <div
    id="anchor-container"
    :class="{
      'anchor-wrapper': true,
      'show': scrollUpFlag,
    }"
  >
    <div :class="{
      'anchor': true,
      'active': partNumber===1,
      }"
    >
      救命救錢的幾秒鐘
    </div>
    <a href="./fault/" @click="sendGA('然後呢point2')">
      <div :class="{
        'anchor': true,
        'active': partNumber===2,
        }"
      >
          斷層旁住滿人
      </div>
    </a>
    <a href="./response/" @click="sendGA('然後呢point3')">
      <div :class="{
        'anchor': true,
        'active': partNumber===3,
        }"
      >
          救災時忙表單
      </div>
    </a>
  </div>
</template>

<script>
import Utils from 'udn-newmedia-utils';
import _debounce from 'lodash.debounce';

export default {
  name: 'Anchor',
  props: {
    partNumber: {
      type: Number,
      default: 1,
    },
    currentPage: {
      type: Number,
    },
    PAGE_AMOUNT: {
      type: Number,
    },
  },
  data() {
    return {
      scrollUpFlag: false,
      lastPageYOffset: 0,
    };
  },
  computed: {
    isMob() {
      return window.innerWidth < 768 ? true : false; 
    },
  },
  methods: {
    sendGA(target) {
      window.ga("newmedia.send", {
        "hitType": "event",
        "eventCategory": "Anchor point",
        "eventAction": "click",
        "eventLabel": "[" + Utils.detectPlatform() + "] [" + document.querySelector('title').innerHTML + "] [" + target + "]"
      });
    },
    handleScroll: _debounce(function(e) {
      // 收闔
      if (this.isMob) {
        if (this.lastPageYOffset > window.pageYOffset) {          
          this.scrollUpFlag = true;
        } else {
          this.scrollUpFlag = false;
        }
      } else {
        this.scrollUpFlag = true;
        // if (this.lastPageYOffset < window.pageYOffset) {
        //   this.scrollUpFlag = true;
        // } else {
        //   this.scrollUpFlag = false;
        // }
      }

      if (window.pageYOffset === 0) {
        this.scrollUpFlag = false;        
      }
      this.lastPageYOffset = window.pageYOffset;
    }, 10),
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
  },
}
</script>

<style lang="scss" scoped>
  .anchor-wrapper {
    position: fixed;
    z-index: 5000;
    top: 0;
    left: 0;
    width: 100%;
    height: 85px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding-top: 35px;
    background-color: #ffffff;
    box-shadow: 0 0 15px 0 rgba(0, 0, 0, 0.11);
    opacity: 0;
    transform: translateY(-85px);
    transition: .666s ease-in-out;
    @media only screen and (min-width: 768px) {
      width: 50px;
      height: 100%;
      flex-direction: column;
      align-items: flex-start;
      padding-top: 100px;
      box-shadow: none;
      opacity: 1;
      transform: translateX(-50px);
    }
    .anchor {
      position: relative;
      font-size: 0.9rem;
      line-height: 2.7rem;
      text-align: center;
      color: #7b7a7a;
      margin: 0 10px;
      transition: .666s ease-in-out;
      cursor: pointer;
      &:last-child {
        border-right: none;
      }
      @media only screen and (max-width: 320px) {
        font-size: 0.8rem;
      }
      @media only screen and (min-width: 768px) {
        max-height: 180px;
        // height: max-content;
        font-size: 1rem;
        color: #000000;
        writing-mode: vertical-rl;
        line-height: 1.3rem;
        padding: 0 10px;
        margin: 15px 0;
        border-left: 3px solid #00000000;
      }
    }
    a {
      color: inherit;
      text-decoration: none;
    }
    .active {
      border-bottom: 2px solid #57b09f;
      @media only screen and (min-width: 768px) {
        border-bottom: none;
        border-left: 3px solid #57b09f;
      }
    }
  }

  .show {
    opacity: 1;
    transform: translateY(0);
    @media only screen and (min-width: 768px) {
      transform: translateX(0);
    }
  }
</style>
